import React from 'react';
import ModalImage from "react-modal-image";



const ImageCollection = ({imgDir, count}) => {
const imageList = [... new Array(count)].map((Number, index)=> `/images/${imgDir}/${index+1}.JPG`);


  return (
    <>
    <ul className='image-collection-container'>{
        imageList.map((imgUrl, index) => {
           return (
            <li className='item tall' >
                <figure>

                <ModalImage className='modal-image'
                    small={imgUrl}
                    large={imgUrl}
                    alt=""/>      

                </figure> 
            </li>
           );
        })
        
        
        }
        
    </ul>
    
    </>
  );
};

export default ImageCollection